<!-- TILE VIEW -->
<!-- IMPORTANT NOTE : A LOT of this HTML and scss was taken from our draggableunitblockcontainer.html and
   block-tile.html. This is because we already have the logic we need in those AngularJS directives / templates to render
   what we need here. So I took those directives and templates and inlined them here, making them work with Angular.
   Would love time to upgrade our AngularJS directives so we could actually use them, instead of 'hacking' them, in
   Angular.-->

<!--
Changed the implementation for allowing the user to click on the tile. This allows Safari users, when clicking the aero
unit tile (and they have the iOS app installed) to open up the ios application and bring that to the forefront.
In essence, this functions the same way as before, just adding functionality to the Safari web-browser and our iOS
application. More information could be found by talking to the senior iOS developer. -->
<a  [attr.href]="(!editMode && renderedInResumeSubSectionView) ? this.generateUnitPath() : null"
  [attr.target]="(!editMode && renderedInResumeSubSectionView) ? '_blank' : null"
  *transloco="let t"
>
  <article [ngClass]="{ 'bulb-block-collection' : unit.unitType === 'CompositeUnit',
            'content-selection-modal-tile' : !renderedInResumeSubSectionView,
            'content-selection-resume-sub-section-view' : renderedInResumeSubSectionView}"
    class="bulb-block-wrapper bulb-block-wrapper-tile" id="{{ uniqueId }}">
    <!--AngularJS HTML from block-tile.html && block-directive.js && block-controller.js -->
    <div class="bulb-block bulb-clickable bulb-block-tile bulb-block-modified"
      [ngClass]="'bulb-accent' + unit.accentIndex">

      <!-- cover image for composite views and for pages for large and up displays -->
      <figure *ngIf="blockType( unit ) === 'collection' || blockType( unit ) === 'page'"
        class="bulb-block-cover-image-tile">
        <a>
          <!-- START OF INLINE image-asset AngularJS directive and HTML -->
          <div *ngIf="unit.image">
            <img [src]="unit.image.url"
              [alt]="t('ajs.content_block_type_IMAGE')"
              class="content-selection-display-unit-cover-image"
              [ngClass]="{'bulb-wide': coverImageAspect( unit ) === 'wide',
                      'bulb-tall': blockType( unit ) === 'page'}"/>
            <div [ngSwitch]=" creditType( unit )" class="bulb-hover-image-view">

              <!-- Show standard credit info at bottom right -->
              <div *ngSwitchCase="'standard'" class="bulb-imageblock-caption">
                <span class="bulb-imageblock-image-caption">
                  <!-- TODO TAM : need to make this work, not needed for this ticket -->
                </span>
              </div>

              <!-- Show credit info in circular form -->
              <div *ngSwitchCase="'circular'" class="bulb-circular-image">
                <span>
                  <svg viewBox="0 0 300 300" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                      <path id="cp2" d="M-120 0A120 120 0 0 0 120 0" fill="none" stroke="red" />
                    </defs>
                    <g transform="translate(160,160)">
                      <!-- Circular background: -->
                      <circle x="0" y="0" r="150" fill="none" stroke="none" />
                      <circle x="0" y="0" r="145" fill="none" stroke="white" stroke-width="4" />
                      <circle x="0" y="0" r="98" fill="none" stroke="white" stroke-width="2" />
                      <!-- Text manipulation starts here: -->
                      <text>
                        <textPath xlink:href="#cp2" path="M-120 0A120 130 0 0 0 130 0"
                          startOffset="70%" text-anchor="middle" dominant-baseline="central"
                          fill="white">
                          <!-- TODO TAM : need to make this work, not needed for this ticket -->
                        </textPath>
                      </text>
                    </g>
                  </svg>
                </span>
              </div>

              <!-- Show credit info icon at bottom right -->
              <div *ngSwitchCase="'icon'" class="bulb-expand-image-view">
                <span class="bulb-expand-image" (click)="openUrlInNewWindow( photographerProfileUrl )">
                  <a class="bulb-external-link" data-tooltip
                    title="{{ photographerName }} {{ t('ajs.assetlibrary_on_text') }} {{ unsplashLabel }}"
                    data-position="top" data-alignment="center">
                  </a>
                </span>
              </div>

              <!-- used for small user small avatar images on comments -->
              <div *ngSwitchCase="'none'">
                <!-- show only image -->
              </div>
            </div>
          </div>
          <!-- END OF INLINE image-asset AngularJS directive and HTML -->
          <img *ngIf="!unit.image" alt="{{ unit.name || t('ajs.block_label_unnamed') }}"
            class="bulb-block-cover-no-image" [src]="'resources/images/bulb_logo.svg' " />
        </a>
      </figure>

      <!-- Unit tile information -->
      <div class="bulb-unit-information" tabindex="0">
        <a class="bulb-block-info" draggable="false">
          <!--If you change this structure of <a> wrapping <div> wrapping <p>,, then
            the same thing in the block-tile.html file as well. needs ellipsis update too -->
          <div *ngIf="blockType( unit ) !== 'archiveCollection'" class="bulb-block-title-wrapper">
            <p
              class="bulb-block-title bulb-block-title-tile content-selection-block-tile-title"
              [attr.aria-label]="unit.name || t('ajs.block_label_unnamed') + 'block_label_' + blockType( unit )">
              {{ unit.name || 'missing_title_' + blockType(unit) }}
            </p>
          </div>
        </a>

        <!-- Footer-->
        <footer class="bulb-tile-footer">
          <!-- Only showing the Collection icon for the unit if applicable. -->
          <div class="aero-unit-tile-footer-container">
            <!-- collection -->
            <div class="aero-unit-tile-footer-container__collection-icon">
              <img *ngIf="blockType( unit ) === 'collection'"
              alt="{{ t('ajs.collection') }}" [src]="'resources/images/bulb_collection.svg' " />
            </div>
            <!-- Delete -->
            <div *ngIf="editMode" class="aero-unit-tile-footer-container__delete-unit-button">
              <i 
                role="button"
                class="fas fa-times-circle" 
                aeroTooltipPosition="top"
                aeroTooltip="{{ t('resume.removePortfolioContent') }}"
                (click)="deleteSelectedPortfolioContent($event, unit)">
              </i>
            </div>
          </div>
        </footer>

      </div>

    </div>

    <div class="bulb-block-wrapper-overlay"></div>
    <!-- Options for collection on hover : -->
    <div *ngIf="unit.unitType === 'CompositeUnit'" class="content-display-collection-button-overlay">
      <aero-button class="content-display-collection-select-button" [size]="buttonSize"
        labelCode="button_select_collection" (onClick)="selectCollection( $event, true )">
      </aero-button>
      <aero-button class="content-display-collection-choose-content-button" [size]="buttonSize"
        labelCode="button_choose_content" (onClick)="selectCollection( $event, false )">
      </aero-button>
    </div>

  </article>
</a>
